export default __webpack_public_path__ + "static/5-04ab6fafd66d67fb108b5fb7897c17d4.jpg";